import script from "./SpacesSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./SpacesSlide.vue?vue&type=script&setup=true&lang=js"

import "./SpacesSlide.vue?vue&type=style&index=0&id=b781a9ba&lang=css"

const __exports__ = script;

export default __exports__